const blogDetailInit = () => {
    const mainPattern = document.querySelectorAll('.gg-blog-detail');
    mainPattern.forEach((module) => {
        const content = module.querySelector('.gg-blog-detail__col-content');
        const containsHeading = content.querySelector('h1, h2, h3') !== null;
        if (!containsHeading) {
            const headingContent = module.querySelector('.wp-block-rank-math-toc-block');
            if(headingContent) {
                headingContent.style.display = 'none';
                
            }
        }
        const images = content.querySelectorAll('img');
        images.forEach((image) => {
            image.style.opacity = '1';
        });
        const placeholderElements = content.querySelectorAll('div[data-placeholder-image][aria-hidden="true"]');
        placeholderElements.forEach((placeholderElement) => {
            if (placeholderElement.textContent === '&nbsp;' || placeholderElement.textContent === '\u00A0') {
                placeholderElement.remove();
            }
        });
        const imgBases = document.querySelectorAll('div:has(>img[role="presentation"])');
        imgBases.forEach((imgBase) => imgBase.remove());
    });
}
blogDetailInit();